import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW1319InputVO } from "../vo/kymw1319-inputVO.model";
import { Injectable } from "@angular/core";
import { KYMW1319Model } from "../kymw1319.model";

export type GetSelectedPlanGoodsFeatureListResponce = {
  SelectedFeatureList: {
    OrderCode: string,
    CatalogFixedFlag: string,
    FeatureCode: string,
    FeatureName: string,
  }[]
}

/**
 * 企画商品特集商品情報取得
 * 
 * @export GetSelectedPlanGoodsFeatureListService
 * @class GetSelectedPlanGoodsFeatureListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetSelectedPlanGoodsFeatureListService extends PlessJsonResponderSub<GetSelectedPlanGoodsFeatureListResponce> {
  model: KYMW1319Model;
  vo: KYMW1319InputVO;
  successFunc: Function;

  /**
   * bodyにセットする値を返す
   * 
   * @returns
   * @memberof GetSelectedPlanGoodsFeatureListService 
   */
  getBody() {
    return new PlessRequest({
      search: {
        SelectedFeatureList: {
          condition: {
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType,
            PCode: this.vo.pcode,
            StartOrderCode: this.model.startOrderCode,
            BundleCatalogFlag: this.vo.bundleCatalogFlag,
          }
        }
      }
    })
  }

  /**
   * API呼び出し
   * 
   * @param vo 
   * @param successFunction
   * @memberof GetSelectedPlanGoodsFeatureListService 
   */
  execute(model: KYMW1319Model, vo: KYMW1319InputVO, successFunction: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunction;
    this.send('getSelectedPlanGoodsFeatureList', this.getBody())
  }

  /**
   * API通信成功時の処理
   * 
   * @param data 
   * @memberof GetSelectedPlanGoodsFeatureListService 
   */
  success(data: GetSelectedPlanGoodsFeatureListResponce): void {
    if (data != null) {
      this.successFunc(data);
    }
  }
}